import { pushEventToDataLayer } from './google-tag-manager';

/**
 * Sets a temporary function that data can be pushed to while Google Analytics is loading.
 * GA will then push this data when it loads.
 */
export const createTemporaryGoogleAnalyticsFn = () => {
  if (!window.gtag) {
    window.dataLayer = window.dataLayer || [];
    window.gtag = function gtag() {
      // eslint-disable-next-line prefer-rest-params
      window.dataLayer?.push(arguments);
    };
  }
};

const createTracker = (trackingId: string) => {
  if (!window.gtag) {
    createTemporaryGoogleAnalyticsFn();
  }
  window.gtag?.('config', trackingId);
};

const createClientTracker = (id: string) => {
  createTracker(id);
};

let initialised = false;

export const injectGAScript = (clientGaKey?: string | null) => {
  if (initialised || !clientGaKey) return;

  createTemporaryGoogleAnalyticsFn();

  window.gtag?.('js', new Date());
  createClientTracker(clientGaKey);

  const gaScript = document.createElement('script');
  gaScript.type = 'text/javascript';
  gaScript.async = true;
  gaScript.setAttribute(
    'src',
    `https://www.googletagmanager.com/gtag/js?id=${clientGaKey}`,
  );

  const head = document.getElementsByTagName('head')[0];
  head.appendChild(gaScript);

  initialised = true;
};

// Will add an event to Google Tag Manager's Data Layer as well as firing off a JavaScript event (for customer's custom analytics)
// Events names will be prefixed with `beamery-convert-`
export const fireAnalyticsEvent = (
  eventNameSuffix: string,
  htmlElement?: HTMLElement,
) => {
  const eventPrefix = 'beamery-convert';
  const eventName = `${eventPrefix}-${eventNameSuffix}`;
  const element = htmlElement ?? window.document.body;

  pushEventToDataLayer({ event: eventName });
  element.dispatchEvent(new Event(eventName, { bubbles: true }));
};
